import { useMemo } from 'react'
import { useTranslation } from 'src/utils/i18n'
import StepLayout from './StepLayout'

const TroubleShooting = () => {
  const { t } = useTranslation('commonAndroid')
  const step = useMemo(
    () => [
      {
        title: (
          <span>
            {t(
              'Check the time shown under the Backup by Google One if its inconsistent with the last backup time click Back up now to back up again'
            )}
            .
          </span>
        ),
        img: [
          {
            src: '/images/login/backup18.png'
          }
        ]
      },
      {
        title: (
          <span>
            {t(
              'Check out the storage of the account if there is no enough cloud storage you need to upgrade the storage plan or try to delete some data'
            )}
            .
          </span>
        ),
        img: [
          {
            src: '/images/login/backup18.png'
          }
        ]
      }
    ],
    [t]
  )

  return <StepLayout title={t('Trouble shooting')} step={step} />
}

export default TroubleShooting
